/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import { Snippet, Highlight } from "react-instantsearch-dom"

import Link from "./link"
import ExternalLinkIcon from "../assets/external-link-icon"

const renderModeTitle = (hit) => {
  switch (hit.category) {
    case "pharma":
      return "GBA Group Pharma"
    case "environment":
      return "GBA Group Environment"
    case "food":
      return "GBA Group Food"
    case "cosmetics":
      return "GBA Group Cosmetics"
    case "veterinary":
      return "GBA Group Veterinary"
    case "medical":
      return "GBA Group Medical Devices"
    case "wasser":
      return "GBA Group Wasser"
    case "construction":
      return "GBA Group Gebäudeschadstoffe & Bausubstanz"
    case "agroChemical":
      return "Agrochemicals"
    case "lifeScience":
      return "GBA Group Life Sciences"
    case "career":
      return "Deine Zukunft bei der GBA Group"
    case "sustainabilityServices":
      return "GBA Group Sustainability Services"
    default:
      return "GBA Group"
  }
}

const renderContentPreview = (hit) => {
  if (hit.description) return <Snippet attribute="description" hit={hit} />
  return <Snippet attribute="content" hit={hit} />
}

const SearchHit = ({ hit, refineLanguage, closeAction, colors }) => {
  const isExternal = Boolean(hit.source_site)
  const categoryColor = hit.category
    ? colors.modes[hit.category]?.primary || colors.modes.group.primary
    : colors.modes.group.primary

  const titleStyle = {
    color: categoryColor,
    textDecoration: "none",
    fontWeight: "600",
  }

  const ctaStyle = {
    color: "text",
    textDecoration: "none",
    borderBottom: "solid 1px",
    borderColor: "text",
    lineHeight: 1.2,
  }

  return (
    <article sx={{ mt: 3 }}>
      <span
        sx={{
          fontSize: "16px",
          fontWeight: "normal",
          display: "inline-block",
        }}
      >
        {" "}
        {renderModeTitle(hit)}{" "}
      </span>
      <h2 sx={{ mt: 1, mb: 0 }}>
        {isExternal ? (
          <a
            href={hit.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => closeAction(false)}
            sx={titleStyle}
          >
            <Highlight attribute="title" hit={hit} />
            <span
              aria-label="Opens in new tab"
              title="Opens in new tab"
              sx={{
                ml: 2,
                display: "inline-block",
                width: "0.85em",
                height: "0.85em",
                lineHeight: 0,
                // Per customer feedback: bottom edge of the icon flush with
                // the bottom of the text. `baseline` sits the icon's bottom
                // on the text baseline (i.e. flush with the bottom of caps).
                verticalAlign: "baseline",
              }}
            >
              <ExternalLinkIcon color={categoryColor} />
            </span>
          </a>
        ) : (
          <Link
            onClick={() => closeAction(false)}
            to={hit.url}
            language={"" + refineLanguage}
            sx={titleStyle}
          >
            <Highlight attribute="title" hit={hit} />
          </Link>
        )}
      </h2>
      <p>{renderContentPreview(hit)}</p>
      <div sx={{ display: "flex", justifyContent: "flex-end" }}>
        {isExternal ? (
          <a
            href={hit.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => closeAction(false)}
            sx={ctaStyle}
          >
            Anzeigen
          </a>
        ) : (
          <Link
            onClick={() => closeAction(false)}
            language={"" + refineLanguage}
            sx={ctaStyle}
            to={hit.url}
          >
            Anzeigen
          </Link>
        )}
      </div>
    </article>
  )
}

SearchHit.propTypes = {
  hit: PropTypes.object.isRequired,
  refineLanguage: PropTypes.array.isRequired,
  closeAction: PropTypes.func.isRequired,
  colors: PropTypes.object.isRequired,
}

export default SearchHit
